var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "body-class": "p-4" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex flex-row justify-content-center",
              attrs: { cols: "1" },
            },
            [
              !_vm.exitCriteria
                ? _c("div", { staticClass: "step" }, [_vm._v("3")])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "11", md: "10" } },
            [
              _c("p", [
                _c("b", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "drip-campaigns.stages." + _vm.i18nMapType + ".question"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "drip-campaigns.stages." +
                          _vm.i18nMapType +
                          ".description"
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c("b-col", { attrs: { cols: "12", md: "8" } }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "bg-clear-gray d-block mb-3 px-4 py-1 text-center",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "drip-campaigns.stages." +
                                  _vm.i18nMapType +
                                  ".pleaseNote"
                              )
                            ) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.words.example")) +
                            ":\n            "
                        ),
                        _c("b", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "drip-campaigns.stages." +
                                    _vm.i18nMapType +
                                    ".exampleText"
                                )
                              )
                          ),
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "drip-campaigns.stages." +
                                  _vm.i18nMapType +
                                  ".exampleParenthesis"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.exitCriteria
                ? _c("b", { staticClass: "text-black text-uppercase bold" }, [
                    _vm._v(_vm._s(_vm.$t("drip-campaigns.exitCriteria"))),
                  ])
                : _c("b", { staticClass: "text-black text-uppercase bold" }, [
                    _vm._v(_vm._s(_vm.$t("drip-campaigns.entryCriteria"))),
                  ]),
              _vm._v(" "),
              _vm._l(_vm.triggersToUse, function (trigger) {
                return _c("drip-campaign-single-criteria", {
                  key: trigger._localId,
                  attrs: {
                    "exit-criteria": _vm.exitCriteria,
                    trigger: trigger,
                    automation: _vm.automation,
                  },
                  on: {
                    "trigger-change": function ($event) {
                      return _vm.handleTriggerChange($event, trigger._localId)
                    },
                    "argument-change": function ($event) {
                      return _vm.handleArgumentChange($event, trigger._localId)
                    },
                    "criteria-delete": function ($event) {
                      return _vm.handleDeleteCriteria(trigger._localId)
                    },
                  },
                })
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "clickable text-primary",
                    on: { click: _vm.handleAddCriteria },
                  },
                  [
                    _vm._v(
                      "\n          + " +
                        _vm._s(_vm.$t("global.words.add")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }